var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chapter-template',{attrs:{"episode":_vm.episode,"chapter":_vm.chapter,"story":_vm.story}})}
var staticRenderFns = []

export { render, staticRenderFns }